import { render } from "./B2bPageTax.vue?vue&type=template&id=61b12e66&scoped=true&lang=pug"
import script from "./B2bPageTax.vue?vue&type=script&lang=js"
export * from "./B2bPageTax.vue?vue&type=script&lang=js"

import "./B2bPageTax.vue?vue&type=style&index=0&id=61b12e66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b12e66"]])

export default __exports__